


































































import Vue, {VueConstructor} from 'vue'
import {RawQuest} from '@/types/entity/RawPoll'
import UiSwitch from '@/components/Ui/Switch/Switch.vue'
import textareaInput from '@/components/Ui/Inputs/TextareaInputAutoHeight.vue'
export default (Vue as VueConstructor<Vue & {
}>).extend({
  props: {
    data: {} as () => RawQuest,
    isEdited: Boolean,
    index: Number,
    hideRemove: Boolean,
    isError: Boolean
  },
  components: {
    UiSwitch,
    textareaInput
  },
  computed: {
    currentQuest: {
      get (): RawQuest {
        return this.data as RawQuest
      },
      set () {
      }
    }
  },
  methods: {
    addQuest () {
      this.$emit('addQuest', this.index)
    },
    removeQuest () {
      this.$emit('removeQuest', this.index)
    },
    onQuestClick () {
      this.$emit('onClick', this.index)
    },
    onInput () {
      this.$emit('change', this.currentQuest)
    },
    addItem () {
      this.currentQuest.items.push({text: `${this.$t('polls.variant')} ${this.currentQuest.items.length + 1}`})
    },
    removeItem (index: number) {
      this.currentQuest.items.splice(index, 1);
    }
  }
})
